"use client";
import React, { useEffect, useState } from "react";
import { Shield, ExternalLink } from "lucide-react";
import { analytics } from "lib/segment";
import { usePathname, useSearchParams } from "next/navigation";
declare global {
  interface Window {
    lintrk: any;
    HubSpotFormsV4: any;
  }
}

const QNDKForm = ({ region, portalId, formId }) => {
  const [noticeIsVisible, setNoticeIsVisible] = useState(false);
  // const [isSuccess, setSuccess] = useState(false);
  const [loading, setLoading] = useState(true);
  // const [url, setUrl] = useState<any>(null);
  // const [os, setOs] = useState<string>("Windows");
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    // Check if user is on Firefox
    const isFirefox = navigator.userAgent.toLowerCase().includes("firefox");

    if (isFirefox && !window.HubSpotFormsV4) {
      setNoticeIsVisible(true);
    }
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/19886599.js";
    script.defer = true;
    document.body.appendChild(script);

    const handleFormSuccess = (event: Event) => {
      const queryString = searchParams.toString();

      const baseUrl = `${window.location.protocol}//${window.location.host}`;
      const currentPath = pathname || window.location.pathname;
      const fullPath = queryString
        ? `${currentPath}?${queryString}`
        : currentPath;

      window.HubSpotFormsV4.getFormFromEvent(event)
        .getFormFieldValues()
        .then((submissionValues: any) => {
          const valuesObj = submissionValues.reduce(
            (acc: Record<string, any>, field: { name: string; value: any }) => {
              acc[field.name] = field.value;
              return acc;
            },
            {},
          );

          // setOs(valuesObj["0-1/qndk_operating_system"]);
          if (
            typeof window !== "undefined" &&
            (window.OnetrustActiveGroups == undefined ||
              window.OnetrustActiveGroups?.includes("2"))
          ) {
            // Segment Identify Call
            analytics.identify({
              firstname: valuesObj["0-1/firstname"],
              lastname: valuesObj["0-1/lastname"],
              email: valuesObj["0-1/email"],
              "company name": valuesObj["0-1/company"],
              jobtitle: valuesObj["0-1/jobtitle"],
              qndk_operating_system: valuesObj["0-1/qndk_operating_system"],
              qndk_compiler_app: valuesObj["0-1/qndk_compiler_app"],
              agreed_to_pii:
                valuesObj["0-1/consent_marketing_emails_and_privacy_policy"],
              consent_product_terms: valuesObj["0-1/consent_product_terms"],
            });

            // Segment Track Call
            analytics.track("QNDK Demo form submitted", {
              link_label: "Submit",
              location: "body",
              page_base_url: baseUrl,
              page_full_url: baseUrl + fullPath,
              resource_interaction: "View a link to download free demo",
            });
          }
        });

      // setSuccess(true);
    };

    const handleFormReady = (event: Event) => {

      // const downloadURLWindowsPython3_12 = await getSignedFileUrl({
      //   objectKey: "qndk-0.1.0-cp312-cp312-win_amd64.whl",
      // });
      // const downloadURLWindowsPython3_13 = await getSignedFileUrl({
      //   objectKey: "qndk-0.1.0-cp313-cp313-win_amd64.whl",
      // });
      // const downloadURLMacPython3_12 = await getSignedFileUrl({
      //   objectKey: "qndk-0.1.0-cp312-cp312-macosx_10_13_universal2.whl",
      // });
      // const downloadURLMacPython3_13 = await getSignedFileUrl({
      //   objectKey: "qndk-0.1.0-cp313-cp313-macosx_10_13_universal2.whl",
      // });
      // const downloadURLLinuxPython3_12 = await getSignedFileUrl({
      //   objectKey: "qndk-0.1.0-cp312-cp312-linux_x86_64.whl",
      // });
      // const downloadURLLinuxPython3_13 = await getSignedFileUrl({
      //   objectKey: "qndk-0.1.0-cp313-cp313-linux_x86_64.whl",
      // });

      // setUrl({
      //   downloadURLWindowsPython3_12: downloadURLWindowsPython3_12,
      //   downloadURLWindowsPython3_13: downloadURLWindowsPython3_13,
      //   downloadURLMacPython3_12: downloadURLMacPython3_12,
      //   downloadURLMacPython3_13: downloadURLMacPython3_13,
      //   downloadURLLinuxPython3_12: downloadURLLinuxPython3_12,
      //   downloadURLLinuxPython3_13: downloadURLLinuxPython3_13,
      // });

      // window.HubSpotFormsV4.getFormFromEvent(event).setFieldValue(
      //   "0-1/quantum_compiler_download_url_windows_python3_12",
      //   downloadURLWindowsPython3_12,
      // );
      // window.HubSpotFormsV4.getFormFromEvent(event).setFieldValue(
      //   "0-1/quantum_compiler_download_url_windows_python3_13",
      //   downloadURLWindowsPython3_13,
      // );
      // window.HubSpotFormsV4.getFormFromEvent(event).setFieldValue(
      //   "0-1/quantum_compiler_download_url_mac_python3_12",
      //   downloadURLMacPython3_12,
      // );
      // window.HubSpotFormsV4.getFormFromEvent(event).setFieldValue(
      //   "0-1/quantum_compiler_download_url_mac_python3_13",
      //   downloadURLMacPython3_13,
      // );
      // window.HubSpotFormsV4.getFormFromEvent(event).setFieldValue(
      //   "0-1/quantum_compiler_download_url_linux_python3_12",
      //   downloadURLLinuxPython3_12,
      // );
      // window.HubSpotFormsV4.getFormFromEvent(event).setFieldValue(
      //   "0-1/quantum_compiler_download_url_linux_python3_13",
      //   downloadURLLinuxPython3_13,
      // );

      setLoading(false);
    };

    script.addEventListener("load", () => {
      window.addEventListener(
        "hs-form-event:on-submission:success",
        handleFormSuccess,
      );
      window.addEventListener("hs-form-event:on-ready", handleFormReady);
      setLoading(false);
    });

    return () => {
      document.body.removeChild(script);
      window.removeEventListener(
        "hs-form-event:on-submission:success",
        handleFormSuccess,
      );
      window.removeEventListener("hs-form-event:on-ready", handleFormReady);
    };
  }, [pathname, searchParams]);

  return (
    <>
      {noticeIsVisible && !window.HubSpotFormsV4 ? (
        <div className="border-orange-200 z-50 my-5  rounded-lg border bg-white p-4 shadow-lg">
          <div className="flex items-start gap-3">
            <div className="mt-0.5 flex-shrink-0">
              <Shield className="text-orange-500 h-5 w-5" />
            </div>

            <div className="min-w-0 flex-1">
              <h3 className="mb-1 text-sm font-semibold text-gray-900">
                Form Blocked by Firefox
              </h3>
              <p className="mb-3 text-sm text-gray-600">
                Firefox's Enhanced Tracking Protection may be blocking this
                form. To submit the form, please temporarily disable tracking
                protection for this site.
              </p>

              <div className="space-y-1 text-xs text-gray-500">
                <p>
                  <strong>To disable:</strong>
                </p>
                <p>1. Click the shield icon in your address bar</p>
                <p>2. Toggle off "Enhanced Tracking Protection"</p>
                <p>3. Refresh the page</p>
              </div>

              <a
                href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-2 inline-flex items-center gap-1 text-xs text-blue-600 hover:text-blue-800"
              >
                Learn more about Firefox tracking protection
                <ExternalLink className="h-3 w-3" />
              </a>
            </div>
          </div>
        </div>
      ) 
      // : isSuccess ? (
      //   <div className="flex flex-col gap-3 p-5">
      //     <h4 className="font-h4">Form submitted</h4>
      //     <p className="font-p">
      //       Thank you for submitting the form. We have received your request and
      //       will be in touch soon.
      //     </p>
      //     <div className="flex flex-col gap-1">
      //       <span className="font-p font-semibold">Documentation:</span>
      //       <LinkTrackers
      //         href="/docs/qndk"
      //         target="_blank"
      //         className="text-p text-blue-600 underline hover:text-blue-800"
      //         segmentMsg="QNDK documentation clicked"
      //         segmentOpt={{
      //           link_label: "QNDK Documentation",
      //           location: "body",
      //           resource_interaction: "Visit to QNDK Documentation page",
      //         }}
      //       >
      //         QNDK Documentation
      //         <ExternalLink className="ml-1 inline h-3 w-3" />
      //       </LinkTrackers>
      //     </div>
      //     <div className="flex flex-col gap-1">
      //       <p className="font-p font-semibold">Download links:</p>
      //       {os === "Windows" && (
      //         <>
      //           <LinkTrackers
      //             href={url?.downloadURLWindowsPython3_12}
      //             target="_blank"
      //             segmentMsg="QNDK download clicked"
      //             segmentOpt={{
      //               link_label: "Download QNDK for Windows - Python 3.12",
      //               location: "body",
      //               resource_interaction: "Download QNDK demo",
      //             }}
      //             className="text-p text-blue-600 underline hover:text-blue-800"
      //           >
      //             Download QNDK for Windows - Python 3.12
      //             <ExternalLink className="ml-1 inline h-3 w-3" />
      //           </LinkTrackers>
      //           <LinkTrackers
      //             href={url?.downloadURLWindowsPython3_13}
      //             target="_blank"
      //             segmentMsg="QNDK download clicked"
      //             segmentOpt={{
      //               link_label: "Download QNDK for Windows - Python 3.13",
      //               location: "body",
      //               resource_interaction: "Download QNDK demo",
      //             }}
      //             className="text-p text-blue-600 underline hover:text-blue-800"
      //           >
      //             Download QNDK for Windows - Python 3.13
      //             <ExternalLink className="ml-1 inline h-3 w-3" />
      //           </LinkTrackers>
      //         </>
      //       )}
      //       {os === "Mac" && (
      //         <>
      //           <LinkTrackers
      //             href={url?.downloadURLMacPython3_12}
      //             target="_blank"
      //             segmentMsg="QNDK download clicked"
      //             segmentOpt={{
      //               link_label: "Download QNDK for Mac - Python 3.12",
      //               location: "body",
      //               resource_interaction: "Download QNDK demo",
      //             }}
      //             className="text-p text-blue-600 underline hover:text-blue-800"
      //           >
      //             Download QNDK for Mac - Python 3.12
      //             <ExternalLink className="ml-1 inline h-3 w-3" />
      //           </LinkTrackers>
      //           <LinkTrackers
      //             href={url?.downloadURLMacPython3_13}
      //             target="_blank"
      //             segmentMsg="QNDK download clicked"
      //             segmentOpt={{
      //               link_label: "Download QNDK for Mac - Python 3.13",
      //               location: "body",
      //               resource_interaction: "Download QNDK demo",
      //             }}
      //             className="text-p text-blue-600 underline hover:text-blue-800"
      //           >
      //             Download QNDK for Mac - Python 3.13
      //             <ExternalLink className="ml-1 inline h-3 w-3" />
      //           </LinkTrackers>
      //         </>
      //       )}
      //       {os === "Linux" && (
      //         <>
      //           <LinkTrackers
      //             href={url?.downloadURLLinuxPython3_12}
      //             target="_blank"
      //             segmentMsg="QNDK download clicked"
      //             segmentOpt={{
      //               link_label: "Download QNDK for Linux - Python 3.12",
      //               location: "body",
      //               resource_interaction: "Download QNDK demo",
      //             }}
      //             className="text-p text-blue-600 underline hover:text-blue-800"
      //           >
      //             Download QNDK for Linux - Python 3.12
      //             <ExternalLink className="ml-1 inline h-3 w-3" />
      //           </LinkTrackers>
      //           <LinkTrackers
      //             href={url?.downloadURLLinuxPython3_13}
      //             target="_blank"
      //             segmentMsg="QNDK download clicked"
      //             segmentOpt={{
      //               link_label: "Download QNDK for Linux - Python 3.12",
      //               location: "body",
      //               resource_interaction: "Download QNDK demo",
      //             }}
      //             className="text-p text-blue-600 underline hover:text-blue-800"
      //           >
      //             Download QNDK for Linux - Python 3.13
      //             <ExternalLink className="ml-1 inline h-3 w-3" />
      //           </LinkTrackers>
      //         </>
      //       )}
      //     </div>
      //     <p className="font-p-sm font-medium text-gray-600">
      //       Download link will expire 7 days after receipt.
      //     </p>
      //   </div>
      // )
       : (
        <div>
          {loading && <div className="loader">Loading form...</div>}
          <div
            className="hs-form-frame"
            data-region={region}
            data-form-id={formId}
            data-portal-id={portalId}
          ></div>
        </div>
      )}
    </>
  );
};

export default QNDKForm;
